import { Stack, Typography } from "@mui/material";
import type { Field, ObjectFilter, SelectOption } from "../../api/types/objectTypes";
import ObjectFilterEditorContent from "./ObjectFilterEditorContent";
import ObjectFilterFieldSelect from "./ObjectFilterFieldSelect";
import type { ObjectFilterFieldGroup } from "./ObjectFilterFieldSelect";

interface Props {
  filter: ObjectFilter;
  fieldGroupKey?: string;
  availableFields?: Field[];
  availableFieldGroups?: ObjectFilterFieldGroup[];
  onFieldChange: (field: Field, groupKey: string) => void;
  onFilterChange: (filter: ObjectFilter) => void;
  selectOptions?: SelectOption[];
  startLabel: string;
  error?: string;
}

const ObjectFilterEditor = ({
  filter,
  fieldGroupKey,
  availableFields,
  availableFieldGroups,
  onFieldChange,
  onFilterChange,
  selectOptions,
  startLabel,
  error,
}: Props) => {
  const fieldGroups = availableFieldGroups ?? [{ key: "", label: "", fields: availableFields ?? [] }];

  return (
    <Stack spacing={0.5} sx={{ width: "100%" }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography color="textSecondary" sx={{ minWidth: "3rem" }}>
          {startLabel}
        </Typography>

        <ObjectFilterFieldSelect
          value={{ groupKey: fieldGroupKey, fieldId: filter.fieldId }}
          fieldGroups={fieldGroups}
          onChange={({ groupKey, field }) => onFieldChange(field, groupKey)}
          sx={{ flex: "0 0 12.5rem" }}
        />

        <ObjectFilterEditorContent filter={filter} onFilterChange={onFilterChange} selectOptions={selectOptions} />
      </Stack>
      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </Stack>
  );
};

export default ObjectFilterEditor;
